import React from 'react';
import PropTypes from 'prop-types';
import { Column, Grid, Row } from '@lux/components';
import styled from 'styled-components';

import Anchor from '../Anchor';
import { H1, SubtitleSecondary } from '../Base';
import Notification from '../Notification';
import Spacing from '../Spacing';

const StyledSubtitleSecondary = styled(SubtitleSecondary)`
  color: ${p => p.theme.colours.grey_600};
`;
const CisError = props => {
  const { title, text, ctaText, ctaUrl } = props;

  return (
    <Spacing bottom={5} bottomMd={9}>
      <Grid>
        <Spacing bottom={5}>
          <H1>Corporate Individual Scheme (CIS)</H1>
        </Spacing>
        <Row>
          <Column sm={12} md={8}>
            <Spacing bottom={3} bottomMd={5}>
              <Notification state="danger">{title}</Notification>
            </Spacing>
          </Column>
        </Row>
        <Row>
          <Column>
            {text && <StyledSubtitleSecondary>{text}</StyledSubtitleSecondary>}
            {ctaText && (
              <Anchor target="_blank" href={ctaUrl}>
                {ctaText}
              </Anchor>
            )}
          </Column>
        </Row>
      </Grid>
    </Spacing>
  );
};

CisError.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  ctaText: PropTypes.string,
  ctaUrl: PropTypes.string
};

export default CisError;
